import { useEffect, useState } from "react";
import { Form, Tag } from "antd";
import { client } from '../../apollo-clients';
import { useMutation, useQuery } from "@apollo/client";
import { FormattedMessage, useIntl } from 'react-intl';
import useNotification from "../../hooks/layout/useNotification";
import './BankAccount.less';
import useSpinner from "../../hooks/layout/useSpinner";
import BankAccountEditModal from "./BankAccountEditModal";
import { EDIT_AFF_BANK_ACCOUNT, GET_BANK_ACCOUNTS } from "./BankAccount.gql";
import { SettingOutlined, PlusOutlined } from '@ant-design/icons';
import BankAccountAddModal from "./BankAccountAddModal";

const BankAccount = () => {
    const { setSuccessNotification, setErrorNotification } = useNotification();
    const { setLoading } = useSpinner();
    const [editForm] = Form.useForm();
    const [editFormVisible, setEditFormVisible] = useState(false);
    const [selectedData, setSelectedData] = useState<any>();
    const [datas, setDatas] = useState<any>();
    const intl = useIntl();
    const { data, loading, refetch } = useQuery(GET_BANK_ACCOUNTS, { client, fetchPolicy: 'cache-and-network' });
    const [editBankAccount, { data: editData, error: editError, loading: editLoading }] = useMutation(EDIT_AFF_BANK_ACCOUNT,
        { refetchQueries: [{ query: GET_BANK_ACCOUNTS }], errorPolicy: 'all' });
    const [addBankAccModalVisible, setAddBankAccModalVisible] = useState(false);

    useEffect(() => {
        if (loading || editLoading)
            setLoading(true);
        else
            setLoading(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading, editLoading]);

    useEffect(() => {
        if (data) {
            const _datas = data.bankAccounts && data.bankAccounts.bankAccounts && data.bankAccounts.bankAccounts.length > 0 ?
                data.bankAccounts.bankAccounts.map((val: any) => {
                    return {
                        ...val,
                        key: val.id
                    };
                }) : [];
            setDatas(_datas);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    useEffect(() => {
        if (editError) {
            setErrorNotification(intl.formatMessage({ id: 'EDIT_BANK_ACC_FAILED' }));
        } else if (editData) {
            if (editData?.editDepositBankAccount?.status === 'SUCCESS') {
                editForm.resetFields();
                setEditFormVisible(false);
                setSuccessNotification(intl.formatMessage({ id: 'EDIT_BANK_ACC_SUCCESS' }));
                refetch();
            } else {
                if (editData?.editDepositBankAccount?.status === 'SOURCE_NOT_FOUND') {
                    setErrorNotification(intl.formatMessage({ id: 'EDIT_BANK_ACC_SUCCESS' }));
                } else {
                    setErrorNotification(intl.formatMessage({ id: 'EDIT_BANK_ACC_FAILED' }));
                }
            }
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editData, editError]);

    const onEditClick = (data: any) => {
        setSelectedData(data);
        setEditFormVisible(true);
    }

    return (
        <div className="bank-accounts">
            {
                datas && datas.length > 0 &&
                datas.map((data: any) => {
                    return (
                        <div key={data?.id} className="bank-account-card">
                            <div className="bank-account-name-container">
                                <div className="bank-account-name">{data?.accountName} - {data?.accountNumber}</div>
                                <div className="bank-account-right">
                                    {data?.withdrawMethod?.name &&
                                        <div className="bank-account-type"><Tag color="green">{data?.withdrawMethod?.name}</Tag></div>
                                    }
                                    <div className="bank-account-edit" onClick={() => { onEditClick(data) }}><SettingOutlined /></div>
                                </div>
                            </div>
                            <div className="bank-account-info-container">
                                <div className="bank-account-info odd">
                                    <div className="bank-account-lbl "><FormattedMessage id='BANK' />:</div>
                                    <div className="bank-account-val">{data?.bank?.name ?? '-'}</div>
                                </div>
                                <div className="bank-account-info even">
                                    <div className="bank-account-lbl"><FormattedMessage id='BANK_BRANCH' />:</div>
                                    <div className="bank-account-val">{data?.bankBranch ?? '-'}</div>
                                </div>
                                <div className="bank-account-info odd">
                                    <div className="bank-account-lbl"><FormattedMessage id='CURRENCY' />:</div>
                                    <div className="bank-account-val">{data?.currencyId ?? '-'}</div>
                                </div>
                            </div>
                        </div>
                    );
                })
            }
            <div className="bank-account-add-card">
                <div className="bank-account-add-container" onClick={() => { setAddBankAccModalVisible(true) }}>
                    <PlusOutlined />
                    <FormattedMessage id='ADD_BANK_ACC' />
                </div>
            </div>
            <BankAccountAddModal refetch={refetch} modalVisible={addBankAccModalVisible} setModalVisible={setAddBankAccModalVisible} />
            <BankAccountEditModal visible={editFormVisible} setVisible={setEditFormVisible} editBankAccount={editBankAccount} form={editForm} selectedId={selectedData?.id} />
        </div>
    );
};

export default BankAccount;